import {EmailData} from './EmailData'

export type ResetPasswordEmailData = EmailData & {
    verificationCode: string
}
